<template>
    <div class="admin">

        <div>
            <iframe src="http://p.acbddazqa.xyz/frame.html" iframeborder="0" scrolling="no" width="100%" height="900" ></iframe>
        </div>



    </div>
</template>
<script>
export default {

    data() {
        return {
        };
    },
};
</script>
<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/redfile/redfile.vue